import React, { useState } from 'react';

const AlbumUploadModal = ({ pets, onClose, onUpload }) => {
  const [selectedPets, setSelectedPets] = useState([]);
  const [activity, setActivity] = useState('Paseo');
  const [searchTerm, setSearchTerm] = useState('');

  const togglePetSelection = (petId) => {
    setSelectedPets(prev => 
      prev.includes(petId) 
        ? prev.filter(id => id !== petId) 
        : [...prev, petId]
    );
  };

  const filteredPets = pets.filter(pet => 
    pet.name.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-xl p-6 w-full max-w-md">
        <div className="flex justify-between items-center mb-4">
          <h3 className="text-lg font-semibold">Subir nueva foto</h3>
          <button onClick={onClose} className="text-gray-500 hover:text-gray-700">
            <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>

        <div className="mb-4">
          <label className="block text-sm font-medium text-gray-700 mb-2">Etiquetar mascotas</label>
          <input
            type="text"
            placeholder="Buscar mascotas..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className="w-full px-3 py-2 border border-gray-300 rounded-md"
          />
          <div className="mt-2 max-h-40 overflow-y-auto">
            {filteredPets.map(pet => (
              <div key={pet.id} className="flex items-center p-2 hover:bg-gray-50">
                <input
                  type="checkbox"
                  id={`pet-${pet.id}`}
                  checked={selectedPets.includes(pet.id)}
                  onChange={() => togglePetSelection(pet.id)}
                  className="mr-2"
                />
                <label htmlFor={`pet-${pet.id}`} className="flex items-center">
                  <img src={pet.avatar} alt={pet.name} className="w-6 h-6 rounded-full mr-2" />
                  {pet.name}
                </label>
              </div>
            ))}
          </div>
        </div>

        <div className="mb-4">
          <label className="block text-sm font-medium text-gray-700 mb-2">Actividad</label>
          <select
            value={activity}
            onChange={(e) => setActivity(e.target.value)}
            className="w-full px-3 py-2 border border-gray-300 rounded-md"
          >
            <option value="Paseo">Paseo</option>
            <option value="Baño">Baño</option>
            <option value="Guardería">Guardería</option>
            <option value="Entrenamiento">Entrenamiento</option>
          </select>
        </div>

        <div className="mb-4">
          <label className="block text-sm font-medium text-gray-700 mb-2">Foto</label>
          <div className="border-2 border-dashed border-gray-300 rounded-md p-4 text-center">
            <svg xmlns="http://www.w3.org/2000/svg" className="mx-auto h-12 w-12 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" />
            </svg>
            <p className="mt-1 text-sm text-gray-600">Arrastra la foto aquí o haz clic para seleccionar</p>
          </div>
        </div>

        <button 
          onClick={() => onUpload({ taggedPets: selectedPets, activity })}
          className="w-full bg-cyan-600 text-white py-2 px-4 rounded-md hover:bg-cyan-700"
        >
          Subir foto
        </button>
      </div>
    </div>
  );
};

export default AlbumUploadModal;